import { TypedDocumentNode, gql } from '@apollo/client';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, defineMessages } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { withFragments } from '@sorare/core/src/gql';
import { fantasy } from '@sorare/core/src/lib/glossary';

import { FormatRule } from 'components/so5/Rules/types';

import { getCardBonusRule_so5Leaderboard } from './__generated__/getCardBonusRule.graphql';

const messages = defineMessages({
  defaultMessage: {
    id: 'Rules.getCardBonusRule.defaultMessage',
    defaultMessage: 'Season bonus, XP bonus and Collection bonus do not apply',
  },
});

export const getCardBonusRule = withFragments(
  (so5Leaderboard: getCardBonusRule_so5Leaderboard): FormatRule | null => {
    const { engineConfiguration } = so5Leaderboard;
    const { grade, collection, season } = engineConfiguration;

    if (grade || collection || season) {
      return null;
    }

    return {
      id: 'cardBonus',
      label: (
        <FormattedMessage
          id="Rules.getCardBonusRule.label"
          defaultMessage="No Card Bonus"
        />
      ),
      description: (
        <FormattedMessage
          id="Rules.getCardBonusRule.defaultMessage"
          defaultMessage="Season bonus, XP bonus and Collection bonus do not apply"
        />
      ),
      defaultMessage: messages.defaultMessage,
      title: fantasy.cardBonus,
      icon: <FontAwesomeIcon icon={faCircleXmark} color="var(--c-red-600)" />,
    };
  },
  {
    so5Leaderboard: gql`
      fragment getCardBonusRule_so5Leaderboard on So5Leaderboard {
        slug
        engineConfiguration {
          grade
          collection
          season
        }
      }
    ` as TypedDocumentNode<getCardBonusRule_so5Leaderboard>,
  }
);
